var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('h2',[_vm._v("欢迎：使用阅卷-----"+_vm._s(_vm.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }